import { is } from '@common/is/is'

import type { TBaseVersion, TVersionRestriction } from '../definitions'

import isRestrictedByVariation from './isRestrictedByVariation'

/**
 * Korlátozzuk a verziószám alapján?
 * @param variations - Korlátozások/korlátozás.
 * @param version    - Verziószám.
 */
export default function isRestrictedByVersion (
  variations: TVersionRestriction,
  version: TBaseVersion
): boolean {
  if (is.array(variations)) {
    return variations.some((variation) => isRestrictedByVariation(variation, version))
  }

  return isRestrictedByVariation(variations, version)
}
